<template>
  <div style="min-height: 240px;">
    <div class="chart-title">Week Days</div>
    <div class="settings-button">
      <miniSettings :position="position" :minis="minis" />
    </div>
    <apexchart
      ref="userWeek"
      class="mb-6"
      v-if="data"
      type="bar"
      height="200"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <div class="width-full float-left text-center text-grey no-trades" v-else>NO TRADES</div>
  </div>
</template>

<script>
import miniSettings from "./miniSettings";
export default {
  name: "MiniWeek",
  components: { miniSettings },
  props: ["data", "position", "minis"],

  watch: {
    data: function(val) {
      this.$refs.userWeek.updateSeries([{
        data: val
      }], true, true)
      this.updateColors()
    
    }
  },

  mounted() {
    this.updateColors()
  },
  methods:{
    updateColors(){
  
      var sorted = [];
      this.data.forEach(result =>{
        sorted.push(result)
      })
      sorted = sorted.sort();
      var breakValue = 0
      breakValue = sorted[5];

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          plotOptions: {
            bar: {
              colors: {
                ranges: [
                  {
                    from: -99999999,
                    to: breakValue,
                    color: "#333B47"
                  },
                  {
                    from: breakValue,
                    to: 99999999,
                    color: "#808F9C"
                  }
                ]
              }
            }
          }
        }
      };
    }
  },
  data() {
    return {
      sorted: 0,
      miniType: { Strategies: "minichartsStrategy", Tags: "minichartsTag" },
      chartOptions: {
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top"
            },
            columnWidth: "95%",
            distributed: false,
            colors: {
              ranges: [
                {
                  from: -99999999,
                  to: 0,
                  color: "#333B47"
                },
                {
                  from: 0,
                  to: 99999999,
                  color: "#808F9C"
                }
              ]
            }
          }
        },
        xaxis: {
          labels: {
            show: true,
            style: {
              colors: "#808F9C",
              fontSize: "12px",
              fontFamily: "Roboto, Roboto Condensed Bold, sans-serif"
            }
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          enabled: false
        },
        grid: {
          show: false
        },
        labels: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        dataLabels: {
          offsetY: -20,
          enabled: true,
          formatter: function(val) {
            if (val > 0) return val;
          }
        },
        colors: [],
        chart: {
          toolbar: {
            show: false
          }
        },
        stroke: {
          show: false,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 3,
          dashArray: 0
        }
      },
      series: [{ data: this.data }]
    };
  },
};
</script>

<style>
</style>